import { useEffect, useRef } from 'react';

let adSenseScriptLoaded = false;

function loadAdSenseScript() {
  if (adSenseScriptLoaded) return;
  adSenseScriptLoaded = true;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7124187642725020';
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);
}

export function AdBanner({ dataAdSlot }: { dataAdSlot?: string }) {
  const insRef = useRef<HTMLModElement>(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    const element = insRef.current;
    if (!element) return;

    // Direct check if it's already initialized
    const isAlreadyInitialized = 
      element.getAttribute('data-adsbygoogle-status') === 'done' || 
      element.hasAttribute('data-ad-status') ||
      element.firstChild !== null;

    if (isAlreadyInitialized || initializedRef.current) {
      return;
    }

    let observer: ResizeObserver | null = null;
    let io: IntersectionObserver | null = null;

    const pushAd = () => {
      if (
        initializedRef.current || 
        element.getAttribute('data-adsbygoogle-status') === 'done'
      ) {
        return;
      }

      // Check if there is indeed at least one unactivated adsbygoogle ins tag in the document
      const unactivatedBanners = document.querySelectorAll('ins.adsbygoogle:not([data-adsbygoogle-status="done"]):not([data-ad-status])');
      if (unactivatedBanners.length === 0) {
        return;
      }

      loadAdSenseScript();

      try {
        initializedRef.current = true;
        // @ts-ignore
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error('AdSense error', e);
      }
    };

    io = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        // Only push if element has valid non-zero dimensions to avoid "availableWidth=0" error
        if (element.offsetWidth > 0 && element.offsetHeight > 0) {
          pushAd();
        } else {
          // Wait for the container to get sized/displayed
          observer = new ResizeObserver((sizeEntries) => {
            for (const entry of sizeEntries) {
              if (entry.contentRect.width > 0 && entry.contentRect.height > 0) {
                pushAd();
                observer?.disconnect();
                observer = null;
                break;
              }
            }
          });
          observer.observe(element);
        }
        io?.disconnect();
        io = null;
      }
    }, { rootMargin: '300px' });
    
    io.observe(element);

    return () => {
      if (observer) observer.disconnect();
      if (io) io.disconnect();
    };
  }, []);

  return (
    <div className="w-full min-h-[100px] flex justify-center overflow-hidden items-center relative bg-gray-50/50 dark:bg-gray-900/50">
      <div className="z-10 w-full overflow-hidden flex justify-center">
        <ins
          ref={insRef}
          className="adsbygoogle"
          style={{ display: 'block', minWidth: '320px', minHeight: '100px', width: '100%', height: '100%' }}
          data-ad-client="ca-pub-7124187642725020"
          data-ad-slot={dataAdSlot || "7773273722"}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    </div>
  );
}
